interface ParserFilesUrlProps {
  baseUrl: string
  avatar: string
}

export const ParseFilesUrl = ({ baseUrl, avatar }: ParserFilesUrlProps) => {
  return baseUrl.endsWith('/') ? baseUrl.concat(avatar) : baseUrl.concat('/', avatar)
}